import React from "react";
import AdminServiceTickets from "../../components/dashboard/AdminServiceTickets";

const AdminPlatformGRH = () => (
  <AdminServiceTickets
    serviceCode="grh"
    title="Ressources humaines"
    lead="Les demandes liées au module ressources humaines de Gestion 360."
  />
);

export default AdminPlatformGRH;
